import formSubmit from '../modules/formSubmit';
import { querySelectorId, querySelectorAll, querySelector } from '../functions/querySelectors';
import { FORM_ROW_ERROR_CLASS, FORM_ERROR_ONE_CLASS, BEFORE_SUBMIT_EVENT, DEFAULT_TRANSITION_TIME } from '../config/main';

const SURVEY_FORM_ID = 'survey-box-form';
const HIDE_CLASS = 'js-hide-success';
const TEXT_ATTR = 'data-success-title';

let getForm = function() {
  return querySelectorId(SURVEY_FORM_ID);
};

let formSuccess = function(event) {
  let hides = querySelectorAll(`.${HIDE_CLASS}`, form);
  let texts = querySelectorAll(`[${TEXT_ATTR}]`, form);

  hides.forEach((hide) => {
    hide.style.opacity = 0;
  });

  texts.forEach((text) => {
    text.textContent = text.getAttribute(TEXT_ATTR);
  });

  setTimeout(() => {
    form.classList.add(FORM_SENDED_CLASS);
  }, DEFAULT_TRANSITION_TIME);
};

let beforeSubmit = function(event) {
  let form = getForm();
  let inputs = querySelectorAll('input[type="checkbox"]', form);
  let allow = false;
  let formError = querySelector(`.${FORM_ERROR_ONE_CLASS}`, form);

  formError.classList.remove(FORM_ROW_ERROR_CLASS);

  inputs.forEach((input) => {
    if (input.checked) {
      allow = true;
    }
  });

  if (allow) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  formError.classList.add(FORM_ROW_ERROR_CLASS);
};

export function surveyBlog() {
  let form = getForm();

  if (form) {
    formSubmit(form);
    form.addEventListener('formSuccess', formSuccess);
    form.addEventListener(BEFORE_SUBMIT_EVENT, beforeSubmit);
  }
}
